import { gql } from 'apollo-angular';
import { DISCOUNT_GROUP_RELATION_PRODUCT_BASE_FRAGMENT } from "./discount-group.definition";
import { PRODUCT_FIELDS_FRAGMENT } from "./product-definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_PRODUCT_RELATION_FRAGMENT = gql`
fragment DiscountGroupProductRelation on DiscountGroupProductRelation {
    ...DiscountGroupRelationProductBase
    productId
    product {
        ...ProductFields
    }
}
${DISCOUNT_GROUP_RELATION_PRODUCT_BASE_FRAGMENT}
${PRODUCT_FIELDS_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_PRODUCT_RELATIONS = gql`
query GetDiscountGroupProductRelations($input:DiscountGroupProductRelationSearchInput) {
    getDiscountGroupProductRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupProductRelation
        }
    }
}
${DISCOUNT_GROUP_PRODUCT_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_PRODUCT_RELATION = gql`
query GetDiscountGroupProductRelation($id:String!) {
    getDiscountGroupProductRelation(id: $id) {
        ...DiscountGroupProductRelation
    }
}
${DISCOUNT_GROUP_PRODUCT_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_PRODUCT_RELATION = gql`
mutation SaveDiscountGroupProductRelation($input: DiscountGroupProductRelationInput!) {
    saveDiscountGroupProductRelation(input: $input) {
        ... DiscountGroupProductRelation
    }
}
${DISCOUNT_GROUP_PRODUCT_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_PRODUCT_RELATION = gql`
mutation DeleteDiscountGroupProductRelation($id: String!) {
    deleteDiscountGroupProductRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;